import { Amplify } from 'aws-amplify';

import { runtimeConfig } from 'runtimeConfig';

const { userPoolId, userPoolClientId, domain, redirectSignIn, redirectSignOut } = runtimeConfig.cognito;

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId,
      userPoolClientId,
      loginWith: {
        oauth: {
          domain,
          scopes: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
          redirectSignIn,
          redirectSignOut,
          responseType: 'code',
        },
      },
    },
  },
});
